/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

const highlightStyle = css`
  & strong {
    color: ${Palette.Primary._500};
    font-weight: inherit;
  }
`;

export const Content = styled.div`
  background: #fff;
  width: 100%;
`;
export const ItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  border: 1px solid transparent;
  padding: 0 8px;
  cursor: pointer;
  height: 40px;
  :hover {
    border: 1px solid ${Palette.Primary._300};
    background: ${Palette.Primary._000};
    border-radius: 4px;
  }
  ${({ isSelected }) =>
    isSelected &&
    css`
      border: 1px solid ${Palette.Primary._300};
      background: ${Palette.Primary._000};
      border-radius: 4px;
    `}
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px;
`;

export const ItemName = styled.div`
  text-transform: none;
  font-size: 14px;
  font-weight: 500;
  line-height: 38px;
  color: ${Palette.PrimaryGray._900};
  max-width: 50%;
  min-width: 50%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${highlightStyle}
`;

export const UploadedName = styled.p`
  display: flex;
  align-items: center;
  color: ${Palette.PrimaryGray._400};
  font-size: 12px;
  line-height: 38px;
  text-transform: none;
  white-space: nowrap;
  min-width: 25%;
`;

export const DevicesCount = styled.p`
  color: ${Palette.PrimaryGray._500};
  font-size: 12px;
  line-height: 38px;
  text-transform: none;
  white-space: nowrap;
  min-width: 25%;
  display: flex;
  justify-content: flex-end;
`;
